module.exports = __webpack_public_path__ + "img/vue.f753c33a.png";